import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ChangeLocaleButton from './ChangeLocaleButton';

import logo from '../../static/img/logo.png';

const useStyles = makeStyles((theme) => ({
  fill: {
    flexGrow: 1,
    flexDirection: 'row',
    spacing: 1,
  },
  imageIcon: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginRight: '24px',
  },
  overrideAppBar: {
    backgroundColor: 'white',
  }
}));

interface Props {
  buttons: React.ReactNode[];
  children: React.ReactNode[];
}

export default function CustomAppBar(props: Props) {
  const classes = useStyles();
  return (
    <div className={classes.fill}>
      <AppBar
        position="fixed"
        className={classes.overrideAppBar}>
        <Toolbar>
          <img alt='logo' className={classes.imageIcon} src={logo} />
          <div className={classes.fill}>
            {props.children}
          </div>
          {props.buttons}
          <ChangeLocaleButton />
        </Toolbar>
      </AppBar>
    </div>
  );
}
